import i18n from 'live/services/i18n';
import { FGeneralSettings, MailSettings } from '../common/types/api/report'
import { Recipient } from '../common/types/form'
import { SpreadsheetGeneratorProps } from './components/SpreadsheetGenerator'
import { COLUMN_SEPARATOR, CURRENT_FIELD_NUMBER, GROUP_NAME_FIELD, LINE_SEPARATOR, LOOKUP_KEY_FIELD, LOOKUP_MACRO_FIELD, RECIPIENTS_EMAIL_FIELD } from './components/RecipientGroups/helper/types'
import { LookupListDataModel } from '../common/types/utilities'
import { isEmail } from '../common/components/EmailInputRecipient/helper'
import { cleanWindowsCharacters } from './components/RecipientGroups/helper/formatStringCsvToRecipient'

const generalSettingsValidations = (data: FGeneralSettings): string[] => {
    const result = []
    if (data.title.length && data.title.trim().length === 0) {
        result.push(i18n('Instance name'))
    }

    return result
}

const reportInformationValidations = (data: MailSettings): string[] => {
    const result = []
    if (data.subject.length && data.subject.trim().length === 0) {
        result.push(i18n('E-mail Subject'))
    }
    if (!data.errorRecipients.length) {
        result.push(i18n('Recipients in case of error'))
    }

    return result
}

export const recipientGroupsValidations = (data: Recipient[]): string[] => {
    let countRecipients = 0

    return data.reduce((result, current) => {
        const currentValidations = recipientGroupSingleValidations(current, `${countRecipients}`)
        currentValidations.forEach(validation => {
            if(!result.includes(validation))
                result.push(validation)
        })
        countRecipients += 1

        return result
    }, [] as string[])
}

export const recipientGroupSingleValidations = (data: Recipient, recipientId?: string): string[] => {
    const result: string[] = []
    if (data?.name?.length && data?.name?.trim()?.length === 0) {
        const nameError = `Recipient${recipientId != undefined ?`: ${recipientId}`: ''} hasn't a name`
        if (!result.includes(nameError)) {
            result.push(nameError)
        }
    }

    const emailListError = `Recipient${recipientId != undefined ?`: ${recipientId}`: ''} hasn't e-mail recipients`
    const emailFormatError = `Recipient${recipientId != undefined ?`: ${recipientId}`: ''} has some invalid e-mail at recipients list`
    if (!data?.recipients?.length) {
        if (!result.includes(emailListError)) {
            result.push(emailListError)
        }
    }else{
        if(data?.recipients?.filter(email => !isEmail(email))?.length > 0){
            if(!result.includes(emailFormatError))
                result.push(emailFormatError)
        }
    }

    //validate lookups here 

    return result
}

export const recipientsImportFileValidation = async file => {
    if (file == undefined) return i18n('File is undefined')
    if (file.type && file.type !== 'text/csv') return `${i18n('Invalid type file. Expecting text/csv but get')} ${file.type}`
    const text = await file.text()
    if (text == undefined || text == '') return i18n('Could not read the file. Content is undefined')
    
    const replacedText = cleanWindowsCharacters(text)
    const header = replacedText.split(LINE_SEPARATOR)[0]
    if (header == undefined || header == '')
        return `${i18n('Could not get header info. Donwload the template and fill it propperly. Use')} ${LINE_SEPARATOR} ${i18n('as lines separator')}`

    const fields = header.split(COLUMN_SEPARATOR)
    if (fields == undefined || fields == [])
        return `Could not get header info. Use ${COLUMN_SEPARATOR} as columns separator`

    if (fields.length != CURRENT_FIELD_NUMBER)
        return `Invalid Header info. Donwload the template and fill it propperly. Remember to use ${COLUMN_SEPARATOR} to separate fields`
    
        const uppercaseFields = fields.map(field => field.toUpperCase().trim().replaceAll("_", " "))
    if (!uppercaseFields.includes(GROUP_NAME_FIELD) || !uppercaseFields.includes(RECIPIENTS_EMAIL_FIELD) ||
        !uppercaseFields.includes(LOOKUP_MACRO_FIELD) || !uppercaseFields.includes(LOOKUP_KEY_FIELD))
        return `Invalid header info. The header needs to have all the fields ${[GROUP_NAME_FIELD,RECIPIENTS_EMAIL_FIELD,LOOKUP_MACRO_FIELD,LOOKUP_KEY_FIELD].join(COLUMN_SEPARATOR)}`

    return ''
}

export const addSpreadsheetValidations = (data: SpreadsheetGeneratorProps): string[] => {
    const result = []
    const excel = data?.excel
    const errorStringBase = 'You cannot define spreadsheet tabs with duplicated names.'
    if (excel) {
        excel.forEach(ex =>{
            const sheets = ex.sheets
            if (sheets) {
                const duplicatedNames = sheets
                    .map(tab => tab?.name)
                    .filter((sheetName, idx) => sheets.findIndex(sheet => sheet.name === sheetName) !== idx)
                const duplicatedErrorMsgExists = result.filter(msg => msg.includes(errorStringBase)).length != 0
                
                if (duplicatedNames && duplicatedNames.length > 0 && !duplicatedErrorMsgExists) {
                    result.push(`${errorStringBase} (${duplicatedNames.join(', ')})`)
                }
            }
        })
    }

    return result
}


export const resolveValidations = (section: string, data: unknown): string[] => {
    switch (section) {
        case 'REPORT INFORMATION': {
            return reportInformationValidations(data as MailSettings)
        }
        case 'GENERAL SETTINGS': {
            return generalSettingsValidations(data as FGeneralSettings)
        }
        case 'RECIPIENT GROUPS': {
            return recipientGroupsValidations(data as Recipient[])
        }
        case 'ADD SPREADSHEET': {
            return addSpreadsheetValidations(data as SpreadsheetGeneratorProps)
        }
    }
}
